import { render, staticRenderFns } from "./systemSet.vue?vue&type=template&id=2c440801&scoped=true&"
import script from "./systemSet.vue?vue&type=script&lang=js&"
export * from "./systemSet.vue?vue&type=script&lang=js&"
import style0 from "./systemSet.vue?vue&type=style&index=0&id=2c440801&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c440801",
  null
  
)

export default component.exports